import { createTheme, ThemeProvider } from '@mui/material/styles';
import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import OAuthToken from "./components/OAuthToken";
import PicuPatient from "./components/PicuPatient";
import SelectedPatient from "./components/SelectedPatient";
import RiskAssessment from "./components/RiskAssessment";
import Timeout from "./components/Timeout";
import Debrief from "./components/Debrief";
import Error from "./components/Error";

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router basename="/">
        <Routes>
          <Route path="/" element={ <OAuthToken /> } />
          <Route path="/patient" element={ <PicuPatient /> } />
          <Route path="/selected" element={ <SelectedPatient /> } />
          <Route path="/assessment" element={ <RiskAssessment /> } />
          <Route path="/timeout" element={ <Timeout /> } />
          <Route path="/debrief" element={ <Debrief /> } />
          <Route path="/error" element={ <Error /> } />
        </Routes>
      </Router>    
    </ThemeProvider>
  );
}

export default App;
